export const textPropsPreset = {
  /**
   * TITLE - Default
   */
  'title-xxl': {
    fontSize: {
      mobile: 1.75,
      desktop: 2.125 // 34px

    },
    lineHeight: 'm',
    letterSpacing: 'm' // 0.01em

  },
  'title-xl': {
    fontSize: {
      mobile: 1.75,
      desktop: 1.875 // 30px

    },
    lineHeight: 'm',
    letterSpacing: 'm' // 0.01em

  },
  'title-l': {
    fontSize: 1.625,
    lineHeight: 'm',
    letterSpacing: 'm' // 0.01em

  },
  'title-m': {
    fontSize: {
      mobile: 1.375,
      desktop: 1.5 // 24px

    },
    lineHeight: 'l',
    letterSpacing: 'default' // 0em

  },
  'title-s': {
    fontSize: 1.25,
    lineHeight: 'l',
    letterSpacing: 'default' // 0em

  },
  'title-xs': {
    fontSize: 1.125,
    lineHeight: 'xl',
    letterSpacing: 's' // 0.005em

  },
  'title-xxs': {
    fontSize: 1,
    lineHeight: 'xl',
    letterSpacing: 'm' // 0.01em

  },
  'title-3xs': {
    fontSize: 0.875,
    lineHeight: 'xl',
    letterSpacing: 'm' // 0.01em

  },

  /**
   * TITLE - Uppercase
   */
  'title-up-xxl': {
    fontFamily: 'alt',
    fontSize: {
      mobile: 2,
      desktop: 2.125 // 34px

    },
    fontWeight: 'bold',
    lineHeight: 'm',
    letterSpacing: 'l',
    textTransform: 'uppercase'
  },
  'title-up-l': {
    fontFamily: 'alt',
    fontSize: 1.625,
    fontWeight: 'bold',
    lineHeight: 'm',
    letterSpacing: 'l',
    textTransform: 'uppercase'
  },
  'title-up-xs': {
    fontFamily: 'alt',
    fontSize: 1.125,
    fontWeight: 'bold',
    lineHeight: 'm',
    letterSpacing: 'l',
    textTransform: 'uppercase'
  },
  'title-up-xxs': {
    fontFamily: 'alt',
    fontSize: 1,
    fontWeight: 'bold',
    lineHeight: 'xs',
    letterSpacing: 'l',
    textTransform: 'uppercase'
  },
  'title-up-3xs': {
    fontFamily: 'alt',
    fontSize: 0.875,
    fontWeight: 'bold',
    lineHeight: 'm',
    letterSpacing: 'l',
    textTransform: 'uppercase'
  },

  /**
   * PARAGRAPH
   */
  'paragraph-xl': {
    fontSize: 1,
    lineHeight: 'xl',
    letterSpacing: 'm' // 0.01em

  },
  'paragraph-l': {
    fontSize: 0.875,
    lineHeight: 'xl',
    letterSpacing: 'm' // 0.01em

  },
  'paragraph-m': {
    fontSize: 0.75,
    lineHeight: 'xl',
    letterSpacing: 'm' // 0.01em

  },
  'paragraph-s': {
    fontSize: 0.625,
    lineHeight: 'xl',
    letterSpacing: 'm' // 0.01em

  },

  /**
   * LABEL
   */
  'label-3xl': {
    fontSize: 1.25,
    lineHeight: 'm' // 1.2

  },
  'label-xxl': {
    fontSize: 1.125,
    lineHeight: 'm' // 1.2

  },
  'label-xl': {
    fontSize: 1,
    lineHeight: 'xs',
    letterSpacing: 'm' // 0.01em

  },
  'label-l': {
    fontSize: 0.875,
    lineHeight: 's',
    letterSpacing: 'm' // 0.01em

  },
  'label-m': {
    fontSize: 0.75,
    lineHeight: 'l',
    letterSpacing: 'm' // 0.01em

  },
  'label-s': {
    fontSize: 0.625,
    lineHeight: 'm',
    letterSpacing: 'm' // 0.01em

  },
  'label-up-m': {
    fontSize: 0.75,
    fontWeight: 'bold',
    lineHeight: 'l',
    letterSpacing: 'l',
    textTransform: 'uppercase'
  },
  'label-up-s': {
    fontSize: 0.625,
    fontWeight: 'bold',
    lineHeight: 'm',
    letterSpacing: 'l',
    textTransform: 'uppercase'
  }
};
//# sourceMappingURL=textPropsPreset.js.map